import { render, staticRenderFns } from "./common_left1.vue?vue&type=template&id=54c24002&scoped=true&"
import script from "./common_left1.vue?vue&type=script&lang=js&"
export * from "./common_left1.vue?vue&type=script&lang=js&"
import style0 from "./common_left1.vue?vue&type=style&index=0&id=54c24002&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c24002",
  null
  
)

export default component.exports